import React from 'react'
import { withRouter, Switch, Redirect, Route } from 'react-router-dom'
import LoadableComponent from '../utils/loadable'
import { isUploadResultNewVersionEnabled } from '@/utils/uploadResultAB';
import { canAccessPerformance } from '@/utils/auth';

// 首页
const Home = LoadableComponent(() => import('../views/Home'));
// 活动列表
const ActivityList = LoadableComponent(() => import('../views/Home/activity-list'));
// 重要订单数据统计
const OrderStatistics = LoadableComponent(() => import('../views/Home/order-statistics'));
// 进出管理
const Visitor = LoadableComponent(() => import('../views/Visitor/visitor'))

// 订单页
const Orders = LoadableComponent(() => import('../views/Order/orders'))
const Sample = LoadableComponent(() => import('../views/Order/sample'))
const Experiment = LoadableComponent(() => import('../views/Order/experiment'))
const UploadResult = LoadableComponent(() => import('../views/Order/upload-result'))
const Negative = LoadableComponent(() => import('../views/Order/negative'))
const Settle = LoadableComponent(() => import('../views/Order/settle'))
const Recovery = LoadableComponent(() => import('../views/Order/recovery'))
const Overtime = LoadableComponent(() => import('../views/Order/overtime'))
const Assigned = LoadableComponent(() => import('../views/Order/assigned'))
const Review = LoadableComponent(() => import('../views/Order/review'))
const Finish = LoadableComponent(() => import('../views/Order/finish'))
const Transport = LoadableComponent(() => import('../views/Order/transport'))
const Retest = LoadableComponent(() => import('../views/Order/retest'))
const ScanQRCode = LoadableComponent(() => import('../views/Order/scanQRcode'))
const ScanSample = LoadableComponent(() => import('../views/Order/scanSample'))
const Feedback = LoadableComponent(() => import('../views/Order/feedback'))
const ForwardOrder = LoadableComponent(() => import('../views/Order/forward-order'))

// 个人主页
const User = LoadableComponent(() => import('../views/User/index'))
const Settlement = LoadableComponent(() => import('../views/User/settlement'))
const TeamManagement = LoadableComponent(() => import('../views/User/teamManagement'))
const Account = LoadableComponent(() => import('../views/User/account'))
// 订单详情页
const BalanceDetails = LoadableComponent(() => import('../views/User/BalanceDetails'))

// 订单详情页
const OrderDetail = LoadableComponent(() => import('../views/Order/detail'))

// 结算详情页
const SettleDetail = LoadableComponent(() => import('../views/User/detail'))

// 测试项目页
const TestProject = LoadableComponent(() => import('../views/TestProject'))
const UndeSampleRecord = LoadableComponent(() => import('../views/TestProject/undeSampleRecord.js'))

/** 绩效 */
const Performance = LoadableComponent(() => import('../views/Performance'))

/** 寄样订单排班 */
const SendSampleOrder = LoadableComponent(() => import('../views/SendSampleOrder'))

// 结算管理
const SettlementManagement = LoadableComponent(() => import('../views/settlement/settlement-management'))

/** 实验成本登记 */
const ExperimentCostRegistration = LoadableComponent(() => import('../views/experiment-cost-registration'))

/** 平台协议 */
const Protocol = LoadableComponent(() => import('../views/Platform/protocol'));

/** 仪器管理 */
const InstrumentList = LoadableComponent(() => import('../views/InstrumentManagement/instrumentList/instrumentList.js'));
const AllInstrumentList = LoadableComponent(() => import('../views/InstrumentManagement/allInstrumentList.js')); //原全部-仪器列表
const RuleInfo = LoadableComponent(() => import('../views/InstrumentManagement/ruleInfo'));
const ScheduleList = LoadableComponent(() => import('../views/InstrumentManagement/scheduleList'));
const OperateLog = LoadableComponent(() => import('../views/InstrumentManagement/operateLog'));
const MaintenanceList = LoadableComponent(() => import('../views/InstrumentManagement/maintenanceList'));
const MaintenanceDetail = LoadableComponent(() => import('../views/InstrumentManagement/maintenanceDetail'));
const MaintenanceRecord = LoadableComponent(() => import('../views/InstrumentManagement/maintenanceRecord'))
const BuffetDetail = LoadableComponent(() => import('../views/InstrumentManagement/instrumentList/buffetDetail.js'));
const MachineTimeManagement = LoadableComponent(() => import('../views/InstrumentManagement/machine-time-management.js'));

/** 测试案例库 */
const CaseLibrary = LoadableComponent(() => import('../views/CaseLibrary/caselibrarys.js'));
const CaseLibraryEdit = LoadableComponent(() => import('../views/CaseLibrary/CaseLibraryEdit/index.js'));
// 测试方法库
const CaseLibraryProcess = LoadableComponent(() => import('../views/CaseLibrary/CaseLibraryProcess/index.js'));
const CaseLibraryProcessDetail = LoadableComponent(() => import('../views/CaseLibrary/CaseLibraryProcess/detail.jsx'));
const CaseLibraryProcessEdit = LoadableComponent(() => import('../views/CaseLibrary/CaseLibraryProcessEdit/index.js'));
class ContentMain extends React.Component {
  renderUploadResultRoute = (props) => (
    isUploadResultNewVersionEnabled()
      ? <UploadResult {...props} />
      : <Redirect to="/order/experiment" />
  );
  renderPerformanceRoute = (props) => (
    canAccessPerformance()
      ? <Performance {...props} />
      : <Redirect to="/home" />
  );

  render() {

    return (
      <Switch>
        <Route exact path='/home' component={Home} />
        <Route exact path='/home/activity-list' component={ActivityList} />
        <Route exact path='/home/order-statistics' component={OrderStatistics} />
        <Route exact path='/visitor' component={Visitor} />
        <Route exact path='/order/orders' component={Orders} />
        <Route exact path='/order/sample' component={Sample} />
        <Route exact path='/order/scanQRcode' component={ScanQRCode} />
        <Route exact path='/order/scanSample' component={ScanSample} />
        <Route exact path='/order/experiment' component={Experiment} />
        <Route exact path='/order/upload-result' render={this.renderUploadResultRoute} />
        <Route exact path='/order/negative' component={Negative} />
        <Route exact path='/order/settle' component={Settle} />
        <Route exact path='/order/overtime' component={Overtime} />
        <Route exact path='/order/recovery' component={Recovery} />
        <Route exact path='/order/detail/:osn/:type?' component={OrderDetail} />
        <Route exact path='/order/assigned' component={Assigned} />
        <Route exact path='/order/review' component={Review} />
        <Route exact path='/order/finish' component={Finish} />
        <Route exact path='/order/transport' component={Transport} />
        <Route exact path='/order/retest' component={Retest} />
        <Route exact path='/order/feedback/:osn?/:type?' component={Feedback} />
        <Route exact path='/order/forward-order' component={ForwardOrder} />
        <Route exact path='/testProject' component={TestProject} />
        <Route exact path='/testProject/undeSampleRecord/:providermerchantid/:id?' component={UndeSampleRecord} />
        <Route exact path='/user/index' component={User} />
        <Route exact path='/user/teamManagement' component={TeamManagement} />
        <Route exact path='/user/settlement' component={Settlement} />
        <Route exact path='/performance' render={this.renderPerformanceRoute} />
        <Route exact path='/settlement-management' component={SettlementManagement} />
        <Route exact path='/experiment-cost-registration' component={ExperimentCostRegistration} />
        <Route exact path='/sendSampleOrder' component={SendSampleOrder} />
        <Route exact path='/user/account' component={Account} />
        <Route exact path='/user/detail/:id' component={SettleDetail} />
        <Route exact path='/user/balanceDetails' component={BalanceDetails} />
        <Route exact path='/platform/protocol' component={Protocol} />
        <Route exact path='/instrumentManagement/instrumentList' component={InstrumentList} />
        <Route exact path='/instrumentManagement/allInstrumentList' component={AllInstrumentList} />
        <Route exact path='/instrumentManagement/ruleInfo' component={RuleInfo} />
        <Route exact path='/instrumentManagement/scheduleList' component={ScheduleList} />
        <Route exact path='/instrumentManagement/operateLog' component={OperateLog} />
        <Route exact path='/instrumentManagement/maintenanceList/:merchantBuffetId' component={MaintenanceList} />
        <Route exact path='/instrumentManagement/maintenanceRecord' component={MaintenanceRecord} />
        <Route exact path='/instrumentManagement/maintenanceDetail/:merchantBuffetId/:maintenanceId?' component={MaintenanceDetail} />
        <Route exact path='/instrumentManagement/buffetDetail/:type/:id' component={BuffetDetail} />
        <Route exact path='/instrumentManagement/machineTimeManagement' component={MachineTimeManagement} />
        <Route exact path='/caselibrary/caselibrarys' component={CaseLibrary} />
        <Route exact path="/caselibraryedit/:id?/:edit?" component={CaseLibraryEdit} />
        <Route exact path='/caselibrary/caselibrary-process' component={CaseLibraryProcess} />
        {/* 跟crmv2一致 */}
        <Route exact path='/caselibrary/caselibrary-process-edit/:id?' component={CaseLibraryProcessEdit} />
        <Route exact path='/caselibrary/caselibrary-process/detail/:id' component={CaseLibraryProcessDetail} />
        <Route exact path="/data-analysis-product/product-list" component={LoadableComponent(() => import('@/views/data-analysis-product/product-list'))} />
        <Route exact path="/data-analysis-product/template-management" component={LoadableComponent(() => import('@/views/data-analysis-product/template-management'))} />
        <Route exact path="/data-analysis-product/analysis-data-entry" component={LoadableComponent(() => import('@/views/data-analysis-product/analysis-data-entry'))} />
        <Redirect exact from="/" to="/home" />
        <Redirect exact from='*' to='/404' />
      </Switch>
    )
  }
}

export default withRouter(ContentMain)
